import { InjectionToken } from '@angular/core';

/**
 * Token for configuring the default cache duration in milliseconds
 */
export const CACHE_MAX_AGE = new InjectionToken<number>('cache-max-age', {
  providedIn: 'root',
  factory: () => 5 * 60 * 1000, // 5-minute default
});

/**
 * Token for configuring short-term cache duration in milliseconds
 * Used for no-cache requests to prevent duplicate requests
 */
export const SHORT_TERM_CACHE_MAX_AGE = new InjectionToken<number>('short-term-cache-max-age', {
  providedIn: 'root',
  factory: () => 500, // 500ms default
});
